// extracted by mini-css-extract-plugin
module.exports = {"no-data":"Table_no-data__VbAKf"};